<template id="events-template">
  <slot
    name="content"
    :showEventRegisterForm="showEventRegisterForm"
    >
  </slot>
</template>
<script setup>
import {onMounted} from 'vue'
import useGlobalStore from '../../store/globalStore'
import {useFormSubmit} from '../../composables/useFormSubmit'
const { showEventRegisterForm } = useFormSubmit()

const globalStore = useGlobalStore()

onMounted(() => {
  const element = window.location.hash.substring(1);

  if (element === 'learn-more') {
    const pathArray = window.location.pathname.split('/');

    globalStore.setModal(
      {
        name: 'eventRegisterModal',
        id: pathArray[7],
      }
    )
  }
})

</script>
